"use strict";

module.exports = existence;

function existence() {
  var switcher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var comment;
  return {
    setValue: function (value) {
      var node = this;
      var tagName = node.tagName,
          id = node.id,
          classList = node.classList,
          className = node.className;

      if (!comment) {
        var commentText = tagName;

        if (id) {
          commentText += "#" + id;
        }

        if (className) {
          commentText += "." + [].slice.apply(classList).join('.');
        }

        comment = window.document.createComment(commentText);
      }

      if (typeof switcher === 'function') {
        value = switcher(value); // eslint-disable-line no-param-reassign
      } else if (!switcher) {
        value = !value; // eslint-disable-line no-param-reassign
      }

      if (value) {
        delete node.__replacedByNode;

        if (comment.parentNode) {
          comment.parentNode.insertBefore(node, comment);
          comment.parentNode.removeChild(comment);
        }
      }

      if (!value) {
        node.__replacedByNode = comment;

        if (node.parentNode) {
          node.parentNode.insertBefore(comment, node);
          node.parentNode.removeChild(node);
        }
      }
    }
  };
}